import React, { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "src/@/components/ui/popover";
import { Calendar } from "src/@/components/ui/calendar";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

const DatePicker = ({ selectedDate, onSelect, label }) => {
    const [internalDate, setInternalDate] = useState(selectedDate || new Date());

    return (
        <div className="flex flex-col space-y-2">
            {label && <label className="text-sm text-gray-600">{label}</label>}
            <Popover>
                <PopoverTrigger className="border bg-slate-100 px-4 py-2 rounded-md text-left h-8 items-center text-xs">
                    {format(selectedDate, "EEEE, dd 'de' MMMM", { locale: ptBR })}
                </PopoverTrigger>
                <PopoverContent className="w-72 bg-white shadow-md rounded-lg p-4">
                    <Calendar
                        onSelect={onSelect}
                        selectedDate={selectedDate || new Date()}
                        locale={ptBR}
                        className="mx-auto"
                    />
                </PopoverContent>
            </Popover>
        </div>
    );
};

export default DatePicker;
